import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { Outlet, useLocation } from 'react-router-dom'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import PcGnb from 'src/components/atomic/organisms/common/PcGnb'
import MoMenu from 'src/components/atomic/organisms/common/MoMenu'
import Loading from 'src/components/atomic/Molecules/Loading'
import MoGnb from 'src/components/atomic/organisms/common/MoGnb'
import { LeftLayoutWrap, RightLayoutWrap } from 'src/layout/Layout'
import { ContentsWrap } from 'src/layout/ContentsWrap'
import GoogleMap from 'src/components/etc/GoogleMap/index'

const ServiceTemplate = () => {
  const { currentMedia } = useMediaQueryHook()
  const { pathname } = useLocation()
  const { LocationInfos } = useAppSelector((state: RootState) => state.locationHistory)
  return (
    <>
      <PcGnb />
      <MoMenu />
      <Loading />
      <LeftLayoutWrap media={currentMedia} $path={pathname}>
        <ContentsWrap media={currentMedia}>
          <Outlet />
        </ContentsWrap>
      </LeftLayoutWrap>
      <RightLayoutWrap
        media={`${currentMedia}`}
        $path={pathname}
        $locationInfolength={LocationInfos?.length}
      >
        {LocationInfos?.length > 0 && <GoogleMap />}
      </RightLayoutWrap>
      <MoGnb />
    </>
  )
}
export default ServiceTemplate
